import React, { useEffect, useState } from 'react';
import { Table, Input, Empty, Button } from 'antd';
import { receptionsService } from '../../services/ReceptionsService';
import { useNavigate, Link } from 'react-router-dom';
import './Receptions.scss';
import Menu from '../../components/Menu/Menu';
import MobileBottomMenu from '../../components/MobileBottomMenu/MobileBottomMenu';
import MobileMenu from "../../components/Menu/MobileMenu";
import ReactPaginate from 'react-paginate';
import Header from "../../components/Header/Header";
const { Search } = Input;

const Receptions = () => {
  const navigate = useNavigate();

  const [receptions, setReceptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [pagination, setPagination] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const hasNoReceptions = receptions.length === 0 && searchQuery.trim().length === 0;

  useEffect(() => {
    receptionsService.getReceptions()
      .then(response => {
        setReceptions(response.data.receipts);
        setPagination(response.data.pagination);
        setCurrentPage(1);
      })
      .catch(error => {
        setError('Failed to fetch receptions.');
        console.error('Error fetching receptions:', error);
      })
      .finally(() => setLoading(false));
  }, []);

  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1;
    setCurrentPage(selectedPage);

    receptionsService.getReceptions(selectedPage)
      .then(response => {
        if (response.status === 401) {
          navigate("/login");
        } else {
          setReceptions(response.data.receipts);
          setPagination(response.data.pagination);
        }
      })
      .catch(error => {
        if (error.response && error.response.status === 401) {
          navigate("/login");
        } else {
          console.error('Error fetching data:', error);
        }
      });
  };

  const handleSearch = (value) => {
      setSearchQuery(value);

      if (value.length > 0) {
        receptionsService.searchReception(value, 1)
            .then(response => {
                if (response.status === 401) {
                    navigate("/login");
                } else {
                    setReceptions(response.data.receipts);
                }
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    navigate("/login");
                } else {
                    console.error('Error fetching search results:', error);
                }
            });
      } else {
        receptionsService.getReceptions()
          .then(response => {
            setReceptions(response.data.receipts);
            setPagination(response.data.pagination);
            setCurrentPage(1);
          })
          .catch(error => {
            setError('Failed to fetch receptions.');
            console.error('Error fetching receptions:', error);
          })
      }
  };

  const columns = [
    {
      title: 'Număr',
      dataIndex: 'number',
      key: 'number',
    },
    {
      title: 'Furnizor',
      dataIndex: ['supplier', 'name'],
      key: 'supplier_name',
    },
    {
      title: 'Data Emiterii',
      dataIndex: 'issue_date',
      key: 'issue_date',
    },
    {
      title: 'Data Recepției',
      dataIndex: 'receiving_date',
      key: 'receiving_date',
    },
    {
      title: 'Nr. Factură',
      dataIndex: 'invoice_number',
      key: 'invoice_number',
    },
    {
      title: 'Serie + Data Factură',
      key: 'invoice_details',
      render: (record) => `${record.invoice_series} - ${record.invoice_date}`,
    },
    {
      title: 'Vezi Recepția',
      key: 'view_reception',
      render: (record) => <Link to={`/receptie/${record.id}`}>Vezi Recepția</Link>,
    }
  ];

  if (loading) return <div className="loading">Loading...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className='standard receptions'>
      <Header />
      <div className="standard__container">
        <div className='standard__mobile-header'>
          <img src='/images/logo.png' alt='logo' className='standard__only-mobile standard__mobile-logo' />
          <MobileMenu />

        </div>
        <Menu />
        <div className='standard__wrapper receptions__wrapper'>
          <h2 className='receptions__title'>Recepții</h2>
          <div className='search__search-area'>
              <Search
                  className="search__search-input"
                  placeholder="Caută recepții..."
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchQuery}
                  enterButton
              />
          </div>
          {hasNoReceptions ? (
            <div className="receptions__empty-state">
              <Empty
                description="Nu există recepții importate încă."
              />
              <Button type="primary" onClick={() => navigate('/import-receptions')}>
                Importă recepții
              </Button>
            </div>
          ) : (
            <>
              <div className="table-container receptions__table-container">
                <Table
                  columns={columns}
                  dataSource={receptions}
                  rowKey="id"
                  pagination={false}
                  scroll={{ x: 'max-content' }}
                />
              </div>
              {pagination && pagination.total_pages > 1 && (
                <ReactPaginate
                  previousLabel={'<'}
                  nextLabel={'>'}
                  breakLabel={'...'}
                  breakClassName={'break-me'}
                  pageCount={pagination.total_pages}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={1}
                  onPageChange={handlePageClick}
                  containerClassName={'pagination'}
                  subContainerClassName={'pages pagination'}
                  activeClassName={'active'}
                />
              )}
            </>
          )}
        </div>
      </div>

      <MobileBottomMenu />

    </div>
  );
};

export default Receptions;
